import { InjectionToken } from "@angular/core";

export const AI_URL = new InjectionToken<string>("AI_URL");